import api from "app/api";

export async function fetchDepartments() {
  const resp = await api.get("registrationapi/departments");
  const departments = resp?.data?.departments;
  return Array.isArray(departments) ? departments : [];
}

export async function fetchRegistrationRequests() {
  const resp = await api.get("registrationapi/registrationRequests");
  const data = resp?.data || {};
  const requests = data?.requests;
  return {
    tenantTimeZone: data?.tenantTimeZone,
    requests: Array.isArray(requests) ? requests : [],
  };
}

/**
 * @param {string | { uuid: string, inactiveReason?: string }} payload
 *   - string: remove pending request only (e.g. after approval)
 *   - object with inactiveReason: full rejection flow (inactive user + email)
 */
export async function removeRegistrationRequest(payload) {
  const body = typeof payload === "string" ? { uuid: payload } : payload;
  const resp = await api.post("registrationapi/removeRegistrationRequest", body);
  return resp?.data;
}

export async function registerUser(payload) {
  const resp = await api.post("registrationapi/registerUser", payload);
  return resp?.data;
}

